<template>
  <a @click="onClick" target="_blank" rel="noopener noreferrer">
    {{ insertionOrderName }}
  </a>
</template>

<script>
import AdvertiserApi from '@/api/AdvertiserApi'

export default {
  name: 'AdminMapReportListInsertionOrderName',
  props: {
    advertiserId: {
      type: Number,
      required: true,
    },
    insertionOrderId: {
      type: Number,
      required: true,
    },
    insertionOrderName: {
      type: String,
      default: null,
    },
  },
  methods: {
    async onClick() {
      const advertiser = await AdvertiserApi.fetchAdvertiser(this.advertiserId)
      const agencyId = advertiser.item.agencyId
      const location = `/agencies/${agencyId}/advertisers/${this.advertiserId}/insertion_orders?id=${this.insertionOrderId}`
      window.open(location, '_blank', 'noreferrer')
    },
  },
}
</script>
